import React from 'react';

interface MonthNavigationProps {
    currentMonth: Date;
    onPreviousMonth: () => void;
    onNextMonth: () => void;
    onCurrentMonth: () => void;
}

export const MonthNavigation: React.FC<MonthNavigationProps> = ({
    currentMonth,
    onPreviousMonth,
    onNextMonth,
    onCurrentMonth
}) => {
    const formatMonthYear = (date: Date) => {
        return date.toLocaleDateString('fr-FR', { 
            month: 'long', 
            year: 'numeric' 
        });
    };

    const isCurrentMonth = () => {
        const now = new Date();
        return currentMonth.getMonth() === now.getMonth() && 
               currentMonth.getFullYear() === now.getFullYear();
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
            <div className="flex items-center justify-between">
                <div>
                    <h2 className="text-xl font-semibold text-gray-900 capitalize">
                        {formatMonthYear(currentMonth)}
                    </h2>
                    <p className="text-sm text-gray-600 mt-1">
                        Vue calendrier mensuel
                    </p>
                </div>
                
                <div className="flex items-center space-x-2">
                    <button
                        onClick={onPreviousMonth}
                        className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
                        title="Mois précédent"
                    >
                        <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    
                    {!isCurrentMonth() && (
                        <button
                            onClick={onCurrentMonth}
                            className="px-3 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors"
                        >
                            Ce mois
                        </button>
                    )}
                    
                    <button
                        onClick={onNextMonth}
                        className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
                        title="Mois suivant"
                    >
                        <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};